module.exports=[
  {
    "Name": "Eastside Prep",
    "privateORhigherEd": "Private",
    "GradeLevel": "5–12",
    "District": "Kirkland",
    "NumberofClosedDays": 30,
    "ClosureDates": "3/3–4/13 (classes held online)",
    "Source": "OSPI",
    "startDate": "3/3",
    "endDate": "4/13",
    "online": "classes held online until 4/13",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "EastsidePrep"
  },
  {
    "Name": "Willows Preparatory School",
    "privateORhigherEd": "Private",
    "GradeLevel": "6–10",
    "District": "Redmond",
    "NumberofClosedDays": 4,
    "ClosureDates": "3/2, 3/4–3/6 (classes held online)",
    "Source": "OSPI",
    "startDate": "3/4",
    "endDate": "3/10",
    "online": "classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "WillowsPreparatorySchool"
  },
  {
    "Name": "Seattle Country Day School",
    "privateORhigherEd": "Private",
    "GradeLevel": "K–8",
    "District": "Seattle",
    "NumberofClosedDays": 34,
    "ClosureDates": "3/3–3/10 (closed), 3/11–4/20 (classes held online + spring break week)",
    "Source": "OSPI",
    "startDate": "3/3",
    "endDate": "4/20",
    "online": "classes held online + spring break week from 3/11 to 4/20",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "SeattleCountryDaySchool"
  },
  {
    "Name": "The Kineo School",
    "privateORhigherEd": "Private",
    "GradeLevel": "K–5",
    "District": "Kirkland",
    "NumberofClosedDays": 9,
    "ClosureDates": "3/9–3/20 (classes held online)",
    "Source": "OSPI",
    "startDate": "3/9",
    "endDate": "3/20",
    "online": "classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "TheKineoSchool"
  },
  {
    "Name": "The Overlake School",
    "privateORhigherEd": "Private",
    "GradeLevel": "5–12",
    "District": "Redmond",
    "NumberofClosedDays": 9,
    "ClosureDates": "3/9–3/10 (closed), 3/11–3/20 (classes held online)",
    "Source": "OSPI",
    "startDate": "3/9",
    "endDate": "3/20",
    "online": "classes held online 3/11 to 3/20",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "TheOverlakeSchool"
  },
  {
    "Name": "Bertschi School",
    "privateORhigherEd": "Private",
    "GradeLevel": "PreK–5",
    "District": "Seattle",
    "NumberofClosedDays": 15,
    "ClosureDates": "3/9–3/13 (closed), 3/16–3/27",
    "Source": "OSPI",
    "startDate": "3/9",
    "endDate": "3/27",
    "online": "",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "BertschiSchool"
  },
  {
    "Name": "The Evergreen School",
    "privateORhigherEd": "Private",
    "GradeLevel": "PreK–8",
    "District": "Shoreline",
    "NumberofClosedDays": 25,
    "ClosureDates": "3/9–4/12 (classes held online)",
    "Source": "OSPI",
    "startDate": "3/9",
    "endDate": "4/12",
    "online": "classes held online until 4/12",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "TheEvergreenSchool"
  },
  {
    "Name": "Lakeside School",
    "privateORhigherEd": "Private",
    "GradeLevel": "5–12",
    "District": "Seattle",
    "NumberofClosedDays": 26,
    "ClosureDates": "3/9–4/14 (classes held online + spring break week)",
    "Source": "OSPI",
    "startDate": "3/9",
    "endDate": "4/14",
    "online": "classes held online + spring break week",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "LakesideSchool"
  },
  {
    "Name": "St. Thomas School",
    "privateORhigherEd": "Private",
    "GradeLevel": "PreK–8",
    "District": "Medina",
    "NumberofClosedDays": 30,
    "ClosureDates": "3/9–4/20 (classes held online + spring break week)",
    "Source": "OSPI",
    "startDate": "3/9",
    "endDate": "4/20",
    "online": "classes held online + spring break week",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "St.ThomasSchool"
  },
  {
    "Name": "The Bush School",
    "privateORhigherEd": "Private",
    "GradeLevel": "K–12",
    "District": "Seattle",
    "NumberofClosedDays": 15,
    "ClosureDates": "3/9–3/10 (closed), 3/11–3/27 (classes held online)",
    "Source": "OSPI",
    "startDate": "3/9",
    "endDate": "3/27",
    "online": "classes held online from 3/11–3/27",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "TheBushSchool"
  },
  {
    "Name": "Brighton School",
    "privateORhigherEd": "Private",
    "GradeLevel": "PreK–8",
    "District": "Mountlake Terrace",
    "NumberofClosedDays": 3,
    "ClosureDates": "3/6–3/10",
    "Source": "OSPI",
    "startDate": "3/6",
    "endDate": "3/10",
    "online": "",
    "SchoolorDistrict": "School",
    "county": "Snohomish",
    "id": "BrightonSchool"
  },
  {
    "Name": "Providence Classical Christian School",
    "privateORhigherEd": "Private",
    "GradeLevel": "PreK–12",
    "District": "Bothell",
    "NumberofClosedDays": 9,
    "ClosureDates": "3/10–3/20 (classes held online)",
    "Source": "OSPI",
    "startDate": "3/10",
    "endDate": "3/20",
    "online": "classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "ProvidenceClassicalChristianSchool"
  },
  {
    "Name": "French American School of Puget Sound",
    "privateORhigherEd": "Private",
    "GradeLevel": "PreK–8",
    "District": "Mercer Island",
    "NumberofClosedDays": 11,
    "ClosureDates": "3/10–3/25 (classes held online)",
    "Source": "OSPI",
    "startDate": "3/10",
    "endDate": "3/25",
    "online": "classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "FrenchAmericanSchoolofPugetSound"
  },
  {
    "Name": "Montessori Academy at Spring Valley",
    "privateORhigherEd": "Private",
    "GradeLevel": "PreK–8",
    "District": "Federal Way",
    "NumberofClosedDays": 3,
    "ClosureDates": "3/10–3/13 (classes held online)",
    "Source": "OSPI",
    "startDate": "3/10",
    "endDate": "3/13",
    "online": "classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "MontessoriAcademyatSpringValley"
  },
  {
    "Name": "University Prep",
    "privateORhigherEd": "Private",
    "GradeLevel": "",
    "District": "Seattle",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "their website",
    "startDate": "3/9",
    "endDate": "further notice",
    "online": "classes began online 3/10",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "UniversityPrep"
  },
  {
    "Name": "Seattle Academy",
    "privateORhigherEd": "Private",
    "GradeLevel": "6-12",
    "District": "Seattle",
    "NumberofClosedDays": "",
    "ClosureDates": "3/10 - 4/20",
    "Source": "their website",
    "startDate": "",
    "endDate": "4/20",
    "online": "classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "SeattleAcademy"
  },
  {
    "Name": "Open Window School",
    "privateORhigherEd": "Private",
    "GradeLevel": "K-8",
    "District": "Bellevue",
    "NumberofClosedDays": "",
    "ClosureDates": "3/16-27",
    "Source": "email from school head",
    "startDate": "3/16",
    "endDate": "3/27",
    "online": "classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "OpenWindowSchool"
  },
  {
    "Name": "Auburn Adventist Academy",
    "privateORhigherEd": "Private",
    "GradeLevel": "",
    "District": "Auburn",
    "NumberofClosedDays": "",
    "ClosureDates": "3/6 - 3/20 (then spring break)",
    "Source": "email from school head",
    "startDate": "3/6",
    "endDate": "3/20",
    "online": "classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "AuburnAdventistAcademy"
  },
  {
    "Name": "King's Schools",
    "privateORhigherEd": "Private",
    "GradeLevel": "All grades",
    "District": "Shoreline",
    "NumberofClosedDays": "",
    "ClosureDates": "3/10-4/8",
    "Source": "school website; email",
    "startDate": "3/10",
    "endDate": "4/8",
    "online": "classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "King'sSchools"
  },
  {
    "Name": "Northwest School",
    "privateORhigherEd": "Private",
    "GradeLevel": "6-12",
    "District": "Seattle",
    "NumberofClosedDays": "",
    "ClosureDates": "3/11-3/27",
    "Source": "school website; email",
    "startDate": "3/11",
    "endDate": "3/27",
    "online": "classes online 3/16-27; days off already planned 12/13",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "NorthwestSchool"
  },
  {
    "Name": "Meridian School",
    "privateORhigherEd": "Private",
    "GradeLevel": "K-5",
    "District": "Seattle",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "school website; email",
    "startDate": "3/10",
    "endDate": "3/20",
    "online": "distance learning",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "MeridianSchool"
  },
  {
    "Name": "Bishop Blanchet High School",
    "privateORhigherEd": "Private",
    "GradeLevel": "",
    "District": "",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "",
    "startDate": "3/12",
    "endDate": "3/31",
    "online": "digital distance learning plan in place",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "BishopBlanchetHighSchool"
  },
  {
    "Name": "Charles Wright Academy",
    "privateORhigherEd": "Private",
    "GradeLevel": "",
    "District": "Tacoma",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "email from school admin",
    "startDate": "3/16",
    "endDate": "4/6",
    "online": "",
    "SchoolorDistrict": "School",
    "county": "Pierce",
    "id": "CharlesWrightAcademy"
  },
  {
    "Name": "Cascadia Montessori School",
    "privateORhigherEd": "Private",
    "GradeLevel": "",
    "District": "Redmond",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "email from school admin",
    "startDate": "3/13",
    "endDate": "4/10",
    "online": "",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "CascadiaMontessoriSchool"
  },
  {
    "Name": "Seattle Waldorf School",
    "privateORhigherEd": "Private",
    "GradeLevel": "",
    "District": "Seattle",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "email from school admin",
    "startDate": "3/12",
    "endDate": "further notice",
    "online": "",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "SeattleWaldorfSchool"
  },
  {
    "Name": "O'Dea High School",
    "privateORhigherEd": "Private",
    "GradeLevel": "",
    "District": "Seatte",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "email from school admin",
    "startDate": "3/12",
    "endDate": "3/25",
    "online": "digital distance learning plan in place",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "O'DeaHighSchool"
  },
  {
    "Name": "Eastside Catholic School",
    "privateORhigherEd": "Private",
    "GradeLevel": "",
    "District": "Sammamish",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "email from school admin",
    "startDate": "3/13",
    "endDate": "4/20",
    "online": "Digital learning starting 3/16",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "EastsideCatholicSchool"
  }
]